<template>
  <div v-if="init == 'default' || init == 'name'">
    <v-select
      :items="selectbox"
      outlined
      background-color="white"
      v-model="data.Records[0].value"
      label="ユーザ名"
    >
    </v-select>
  </div>
  <div v-else-if="init == 'auto'">
    <v-text-field
      value="ユーザ名(自動入力)"
      :rules="rules"
      :label="label"
      disabled
      type="text"
      outlined
      background-color="white"
    ></v-text-field>
  </div>
</template>

<script>
export default {
  props: {
    //"default": //ユーザ情報設定用ユーザリストフォーム selectbox
    record: Object,
    label: String,
    init: String,
    //"name": //ユーザ名(既存値優先・入力可) //selectbox

    //"auto": //ユーザ名(自動・入力不可)  textbox
  },
  data() {
    return {
      data: {
        Page_id: 0,
        Report_id: null,
        Records: [{ value: "ユーザ名", form_id: 0, form_type: 2 }],
      },
      //
      selectbox: ["ユーザ1", "ユーザ2", "リストが自動表示"],
      rules: { required: (value) => !!value || "必須項目です" },
    };
  },
  async mounted() {},
};
</script>

<style></style>
